module.exports = __webpack_public_path__ + "img/students5.59f47477.jpg";